import React from "react";
import Container from "components/layout/Container";
import AdditionalInfo from "containers/ProductDetails/components/AdditionalInfo";
import Images from "./Images/";
import Details from "./Details/";
import { CoBrandingLogo } from "components/CoBrandingLogo";
import StandardComponents from "./StandardComponents/";
import OptionalComponents from "./OptionalComponents/";
import { FooterCTABoxes } from "./../../../../components/FooterCTABoxes";
import { productTypeNormalization } from "utility/routeTranslation";
import { Button, Icon, Heading } from "@masonite/external-ui-react";
import s from "./index.module.scss";
import classNames from "classnames/bind";
import { language } from "utility/env";
import { moveVideosToBottom } from "./../../helpers";
import { mArrowLeft } from '@masonite/svg-icons';

const cx = classNames.bind(s);

const buildURLRedirect = productType => {
    let splitPathname = window.location.pathname.split("/");
    let redirectURL = `${window.location.origin}/`;

    splitPathname.forEach(path => {
        if (path !== "") {
            redirectURL += `${path}/`;

            if (path === "door") {
                redirectURL += `${productType}/`;
            }
        }
    });

    // Remove the / at the end of the URL
    redirectURL = redirectURL.substring(0, redirectURL.length - 1);

    return redirectURL;
};

const ProductDetails = props => {
    const {
        activeTab,
        product,
        options,
        history,
        lastCatalogPath,
        interiorRoute,
        exteriorRoute,
        allDoorsRoute
    } = props;

    const images = activeTab ? activeTab.images : [];

    const sortedImages = moveVideosToBottom(images);

    var hideButton = {
        visualizeDoor: {
            display: "none"
        }
    };

    var showButton = {
        visualizeDoor: {
            display: "block",
            float: "right"
        }
    };

    // Temp styles for Visualize Door Button
    const visualizeDoorStyle = () => {
        if (
            window.innerWidth > 500 ||
            window.location.origin === "https://residential.masonite.com"
        ) {
            return hideButton;
        } else {
            return showButton;
        }
    };

    return (
        <>
            <main className={s.Main}>
                <section className={s.productDetailToolbar}>
                    <Container>
                        <div className={s.toolbarRow}>
                            <div className={s.toolbarCol}>
                                <div className={s.toolbarFlexWrapper}>
                                    <Button
                                        variant="light"
                                        onClick={option => {
                                            if (lastCatalogPath) {
                                                history.push(lastCatalogPath);
                                            } else {
                                                history.push(allDoorsRoute);
                                            }
                                        }}
                                    >
                                    <Icon svg={mArrowLeft} />
                                    </Button>
                                    <Heading level="3">{product.title}</Heading>
                                </div>
                            </div>
                            <div className={cx(s.toolbarCol, s.logoCol)}>
                                <CoBrandingLogo />
                            </div>
                        </div>
                    </Container>
                </section>
                <Container>
                    <div className={s.Grid}>
                        <Images {...props} images={sortedImages} />
                        <Details {...props} />
                    </div>
                    <div className={s.doorComponents}>
                        {options.standard_component.length > 0 && (
                            <StandardComponents {...props} />
                        )}
                        {options.optional_component.length > 0 && (
                            <OptionalComponents {...props} />
                        )}
                    </div>
                </Container>
            </main>
            <AdditionalInfo product={product} />
            
            <FooterCTABoxes />

        </>
    );
};

export default ProductDetails;
